import {
  ItemTypeEnum,
  ProductTypeEnum,
  type VeneerProduct,
  getBaseProductSchema,
  productMaterialCharacteristicsSchema,
  productPreferencesSchema,
  veneerItemSchema,
} from "@jasper/client-models";
import {
  isTeethStepComplete,
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { MaterialStep, PreferencesStep, ToothStep } from "./constants";

export type VeneerStepKey =
  | typeof StepKeysEnum.material
  | typeof StepKeysEnum.preferences
  | typeof StepKeysEnum.tooth;

export const VeneerWorkflowConfiguration: ProductWorkflowConfiguration<
  VeneerProduct,
  VeneerStepKey
> = {
  productType: ProductTypeEnum.veneer,
  itemType: ItemTypeEnum.veneer,
  steps: [new ToothStep(), new MaterialStep(), new PreferencesStep()],
  teethSelection: TeethSelectionEnum.UNIQUE,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({ itemSchema: veneerItemSchema }).safeParse(
      product
    ).success;
  },

  getCompletedSteps(product) {
    const completed: VeneerStepKey[] = [];

    if (
      isTeethStepComplete({
        teeth: product.teeth,
        teethSelection: this.teethSelection,
      })
    ) {
      completed.push(StepKeysEnum.tooth);
    }

    const isMaterialStepComplete =
      productMaterialCharacteristicsSchema.safeParse(product).success;

    if (product.items?.length && isMaterialStepComplete) {
      completed.push(StepKeysEnum.material);
    }

    const isPreferencesStepComplete =
      productPreferencesSchema.safeParse(product).success;

    if (isPreferencesStepComplete) {
      completed.push(StepKeysEnum.preferences);
    }

    return completed;
  },
};
